/**
 * Resolve public meta description for a blog post without inventing marketing copy.
 * Prefer CMS meta_description; otherwise a plain-text prefix of body content.
 */
export function resolveBlogPostMetaDescription(post: {
  meta_description?: string | null;
  content?: string | null;
}): string {
  const fromMeta = (post.meta_description || '').trim();
  if (fromMeta) return fromMeta;

  const raw = (post.content || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return raw.slice(0, 160);
}

/** Apply description to the existing shell/Helmet meta tag so prerender sees it before ready. */
export function applyBlogPostMetaDescriptionToDocument(description: string): void {
  if (typeof document === 'undefined' || !description) return;
  const meta = document.querySelector('meta[name="description"]');
  if (meta) {
    meta.setAttribute('content', description);
  }
}
